"use client";

import { trackError } from "@repo/analytics";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { useEffect } from "react";
import { Button } from "@/app/components/CustomButton";
import { StatusScreen } from "@/app/components/StatusScreen";

type ErrorProps = {
	readonly error: Error & { digest?: string };
	readonly reset: () => void;
};

export default function AppError({ error, reset }: ErrorProps) {
	useEffect(() => {
		trackError(error.message || "Unknown error", "app", error.digest || "");
	}, [error]);

	return (
		<StatusScreen
			tone="error"
			icon={<AlertTriangle />}
			title="Something went wrong"
			description="We hit an unexpected error while loading this page. You can try again, and if it keeps happening, please reach out to our team."
			actions={
				<>
					<Button asChild variant="secondary">
						<a href="/">Go to dashboard</a>
					</Button>
					<Button onClick={() => reset()}>
						<RefreshCw />
						Try again
					</Button>
				</>
			}
			footer={
				error.digest ? (
					<p className="font-mono text-tertiary text-xs">
						Error ID: {error.digest}
					</p>
				) : null
			}
		/>
	);
}
